import { Trans, useTranslation } from "react-i18next"
import { PageLoadingScreen, SplitScreenBackground } from "../components/Background"
import { PageHeader } from "../components/HeaderComponents"
import NavBar from "../components/NavBar"
import { useNavigate } from "react-router-dom"
import { AnnouncementsComponent } from "../components/AnnouncementsComponents"
import { requestAnnouncements } from "../requests/setup_requests"
import { useContext, useEffect } from "react"
import { AccountContext } from "../contexts/AccountContexts"
import { GuestFooter, MemberFooter } from "../components/FooterComponents"
import { FAQHomePage, FAQNoLoginHome } from "../components/FAQComponents"



export const LandingPage = () => {
    const { t } = useTranslation('common')
    const { user } = useContext(AccountContext)
    const navigator = useNavigate()

    useEffect(() => {
        console.info("Welcome to Mobile2 Support!")
    }, [])

    useEffect(() => {
        if (user && user.type !== "temp") {
            navigator("/")
        }
    }, [user])

    return (
        <>
            <SplitScreenBackground />
            <div className="flex flex-col items-center justify-start  pt-2  gap-5">
                <PageHeader pageTitle={t("Home")} />
                <NavBar />
                <PageLoadingScreen />
                <div className="flex flex-col w-full min-h-screen">

                    <main className="flex flex-col justify-start items-center w-full mx-auto max-w-[1200px] z-0 p-1 sm:p-5 ">
                        <AnnouncementsComponent fetchCall={requestAnnouncements} />
                        <div className="flex flex-col gap-3 justify-center items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 p-5 rounded-lg sm:min-w-[400px] pb-10">
                            <span className="text-lg font-semibold py-3">{t("Welcome to Mobile2 Support")}</span>

                            {/* <span className=" items-center gap-1">
                                <Trans i18nKey="home_no_login_message" t={t} values={{ main_site_link: "mobile2.global" }} components={{
                                    a: <a className="underline  text-primary dark:text-sky-200" href="https://mobile2.global" />
                                }} />
                            </span> */}
                            <a href={"https://mobile2.global/login&supportlogin=true"} className="btn border-none bg-primary hover:bg-sky-700 text-white">{t("Sign In")}</a>
                        </div>

                    </main>
                    <div className="self-center mx-1 mt-1 bg-gray-200 dark:bg-gray-700 p-2 rounded-lg">
                        <FAQNoLoginHome />
                    </div>
                </div>
                <div className="mt-auto flex w-full bg-gray-100 dark:bg-gray-700">

                    <GuestFooter />
                </div>
            </div>
        </>

    )
}


const NavButton = ({ name, to }) => {
    const navigator = useNavigate()

    const handleClick = (e) => {
        e.preventDefault()
        navigator(to)
    }

    return (
        <button className="btn w-full max-w-[300px] bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 dark:border-gray-400 dark:hover:border-gray-500 hover:bg-primary hover:text-white" onClick={handleClick}>{name}</button>
    )
}